import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, Upload, Users, Handshake, TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";
import { AIAvatarPresentation } from "./AIAvatarPresentation";

const steps = [
  {
    number: "01",
    icon: Upload,
    title: "List Your Business",
    description: "Create a detailed listing with photos, financials, and business details. Pay $98/month for private sellers, $89/month for brokers - no upfront fees.",
    color: "text-secondary"
  },
  {
    number: "02", 
    icon: Users,
    title: "We Find Buyers",
    description: "Our AI matches your business with qualified buyers from our database of 4,000+ pre-screened purchasers.",
    color: "text-primary"
  },
  {
    number: "03",
    icon: Handshake,
    title: "Connect & Close",
    description: "Receive qualified leads instantly. Pay $15-$19 per lead only when buyers request information. (Leads are free for the first 3 months)",
    color: "text-secondary"
  },
  {
    number: "04",
    icon: TrendingUp,
    title: "Track Progress",
    description: "Monitor listing performance, lead quality, and conversion rates through your web or mobile app dashboard.",
    color: "text-primary"
  }
];

export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            How BizMatch Works
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Straightforward, transparent, and built to get you results. <br />
            <span className="text-primary font-semibold">Manage everything from web or mobile app.</span>
          </p>
        </div>

        {/* AI Avatar Presentation */}
        <AIAvatarPresentation />

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-8 mb-12">
          {steps.map((step, index) => (
            <Card key={index} className="group hover:shadow-medium transition-all duration-300 hover:-translate-y-1 border-border/50">
              <CardContent className="p-6 text-center">
                <div className="mb-6">
                  <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-primary mb-4`}>
                    <step.icon className="h-8 w-8 text-primary-foreground" />
                  </div>
                  <div className={`text-4xl font-bold ${step.color} mb-2`}>
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <Button asChild variant="hero" size="xl" className="group">
            <Link to="/list-business">
              Start Your First Listing
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
          <p className="text-sm text-muted-foreground mt-4">
            No setup fees • Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
}